import { createPortal } from 'react-dom';
export const Portal = ({ children, container, key }) => {
    return createPortal(children, container || document.body, key);
};
//# sourceMappingURL=Portal.js.map